import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { FileText, BookOpen } from "lucide-react";
import { RESOURCES } from "../data/resources";
import ResourceArtwork from "../components/ResourceArtwork";

const FILTERS = [
  { id: "all", label: "All resources" },
  { id: "whitepaper", label: "White papers" },
  { id: "blog", label: "Expert blogs" },
];

export default function Resources() {
  const [filter, setFilter] = useState("all");
  const list = useMemo(
    () => (filter === "all" ? RESOURCES : RESOURCES.filter((r) => r.type === filter)),
    [filter]
  );

  return (
    <>
      <section className="pagehead">
        <div className="container">
          <div className="pagehead-inner">
            <div>
              <div className="section-label"><span className="dot" />Resources</div>
              <h1 className="pagehead-title display" data-testid="resources-h1">
                Research, <em>white papers</em>, and expert commentary.
              </h1>
            </div>
            <p className="pagehead-lede">
              Long-form thinking from the Capexara practice — on capital-project economics, AI in contracts and controls, digital twins, AWP, and the ₹200 lakh crore opportunity.
            </p>
          </div>
        </div>
      </section>

      <section className="resources">
        <div className="container">
          <div className="resource-tabs" data-testid="resource-tabs">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                className={"resource-tab " + (filter === f.id ? "active" : "")}
                onClick={() => setFilter(f.id)}
                data-testid={`resource-tab-${f.id}`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="resource-grid" data-testid="resource-grid">
            {list.map((r) => (
              <Link to={`/resources/${r.id}`} className="resource-card" key={r.id} data-testid={`resource-card-${r.id}`}>
                <div className={"resource-cover resource-cover--art " + r.cover}>
                  <ResourceArtwork id={r.id} />
                  <span className="resource-cover-tag">
                    {r.type === "whitepaper" ? <><FileText size={11} style={{ marginRight: 6, display: "inline" }} /> White paper</> : <><BookOpen size={11} style={{ marginRight: 6, display: "inline" }} /> Blog</>}
                  </span>
                </div>
                <div className="resource-body">
                  <div className="resource-meta">{r.date} · {r.readTime} · {r.author}</div>
                  <div className="resource-title">{r.title}</div>
                  <div className="resource-excerpt">{r.excerpt}</div>
                  <div className="resource-foot">
                    <span>Read</span>
                    <span className="arrow">→</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
